const LOGIN_FAIL_REASONS = {
  USER_NOT_FOUND: 'UserNotFound',
  INCORRECT_CREDENTIALS: 'IncorrectCredentials',
}

export default LOGIN_FAIL_REASONS
